import { connect } from "react-redux";
import { fetchRequests, TOGGLE_REQUEST_DETAILS } from "common/actions/requests";
import { number } from "common/formats";
import { first } from "lodash-es";

import { SummaryBar } from "../common/summaryBar";

const summaries = [
    {
        title: "All requests",
        dataField: "requests_count",
        formatter: number,
        size: 2
    }, {
        title: "Pages",
        description: "All requests grouped by request-group-id",
        dataField: "pages_count",
        formatter: number,
        size: 5
    }, {
        title: "Average request duration",
        dataField: "average_request_time",
        formatter: (value) => `${number(value)}ms`,
        size: 5
    }
];

const mapStateToProps = (state) => ({
    queryDeps: {
        date_range: state.common.date_range,
        qualifiers: state.requests.qualifiers
    },
    section: state.requests.section
});

const mapDispatchToProps = {
    TOGGLE_DETAILS: TOGGLE_REQUEST_DETAILS
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(SummaryBar);

export function SummaryBarRedux(props) {
    return (
        <Connected
            summaries={summaries}
            queryKey="requests"
            queryFn={(...args) => fetchRequests(...args).then((results) => (results && results.length ? first(results) : {}))}
            {...props}
        />
    );
}
